module.exports = __webpack_public_path__ + "img/image-input-placeholder.8d8726c6.svg";